var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5cm",
    height: "2cm",
    viewBox: "0 0 340.19 201.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#231f20;}.cls-2,.cls-6{fill-rule:evenodd;}.cls-3{fill:#f5d792;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:3.86;stroke-width:3.7px;}.cls-5,.cls-6{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "88.76 169.7 107.85 169.7 107.85 159.03 98.99 159.03 98.99 155.2 106.81 155.2 106.81 145.04 98.99 145.04 98.99 141.31 107.55 141.31 107.55 130.64 88.76 130.64 88.76 169.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.95,
    y: 130.64,
    width: 10.15,
    height: 39.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.45,146.7v9.22H143a4.19,4.19,0,0,1-4.11,3.42c-3.3,0-5.23-4-5.23-8.34,0-4.71,2-9.07,5.63-9.07a4.2,4.2,0,0,1,3.86,3l9.49-4.87A15.07,15.07,0,0,0,139,130c-8.79,0-15.5,7.66-15.5,20.41,0,12.54,6.9,19.89,15.42,19.89a14.53,14.53,0,0,0,11.86-6.94c3.3-5,3.3-10.31,3.37-16.68H138.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.09,130.64V152.4c0,3.06-.07,5.75-2.78,5.75s-2.78-2.69-2.78-5.75V130.64H156.38v23.11c0,11.39,5.11,16.57,12.93,16.57s12.94-5.18,12.94-16.57V130.64H172.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "185.63 169.7 204.31 169.7 204.31 157.17 195.79 157.17 195.79 130.64 185.63 130.64 185.63 169.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206,
    y: 130.64,
    width: 10.16,
    height: 39.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.18,166.75a19.56,19.56,0,0,0,10.75,3.57c6,0,12.12-4.61,12.12-13.93,0-6.63-3.11-9.84-7.41-11.19l-2.3-.73c-.78-.25-2-.46-2-1.91a2,2,0,0,1,2.19-2.08c2.18,0,4.15,1.3,5.89,3l2.74-10a13.29,13.29,0,0,0-8.85-3.42c-6.08,0-12.13,5.18-12.13,14.45,0,6.11,3.34,9.38,7.31,10.36l2,.52c.92.26,2.26.42,2.26,2.18a2.41,2.41,0,0,1-2.6,2.33c-2.33,0-4.52-1.61-6.34-3.57l-.52-.57-3.11,11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "241.13 143.33 246.72 142.97 246.72 169.7 256.88 169.7 256.88 142.97 262.47 143.33 262.47 130.64 241.13 130.64 241.13 143.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 264.05,
    y: 130.64,
    width: 10.16,
    height: 39.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.53,169.7h9.72V157a62.1,62.1,0,0,0-.64-7.82h.3l8.93,20.51h9.71V130.64h-9.71v11.71a82.78,82.78,0,0,0,.85,10h-.29l-9.12-21.66h-9.75V169.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.77,169.7h9.71V157a64,64,0,0,0-.63-7.82h.3l8.93,20.51h9.71V130.64h-9.71v11.71a80.78,80.78,0,0,0,.85,10h-.29l-9.12-21.66h-9.75V169.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.15 168.39 81.43 168.6 81.43 130.66 47.61 130.45 47.61 0 1.15 0 1.15 168.39"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.07,
    y: 2.71,
    width: 87.9,
    height: 91.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 67.4,
    y: 18.82,
    width: 87.9,
    height: 91.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 67.4,
    y: 18.82,
    width: 87.9,
    height: 91.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 178.01,
    width: 340.19,
    height: 23.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "25.8 197.83 35.53 197.83 35.53 195.86 28.28 195.86 28.28 182.19 25.8 182.19 25.8 197.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "50.74 197.83 60.45 197.83 60.45 195.86 53.22 195.86 53.22 190.7 59.8 190.7 59.8 188.73 53.22 188.73 53.22 184.16 60.45 184.16 60.45 182.19 50.74 182.19 50.74 197.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 76.8,
    y: 182.19,
    width: 2.48,
    height: 15.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.38,182.71a14.26,14.26,0,0,0-5.09-.79c-5.29,0-9.16,3.21-9.16,8,0,5,3.65,8.15,9.13,8.15a17.41,17.41,0,0,0,5.29-.69v-8.13h-6.13v1.83h3.65v4.76a11.33,11.33,0,0,1-2.78.26c-3.6,0-6.53-2.44-6.53-6.11,0-3.49,2.66-6.12,6.66-6.12a8.62,8.62,0,0,1,4.76,1.08l.2-2.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.84,182.19h-2.48v8.87c0,3-1,5.06-4.25,5.06s-4.24-2.06-4.24-5.06v-8.87h-2.48v9.16c0,4.39,2.45,6.74,6.72,6.74s6.73-2.35,6.73-6.74v-9.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "156.72 197.83 159.21 197.83 159.21 184.3 159.26 184.3 164.99 197.83 167.43 197.83 173.16 184.3 173.21 184.3 173.21 197.83 175.7 197.83 175.7 182.19 171.6 182.19 166.26 195.18 160.82 182.19 156.72 182.19 156.72 197.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 192.6,
    y: 182.19,
    width: 2.48,
    height: 15.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.67,197.83h5.12c5.71,0,9.23-2.71,9.23-8,0-4.81-4.09-7.68-9.23-7.68h-5.12v6.54H210v1.43h1.69v7.67m2.48-13.67H217c3.82,0,6.38,2.45,6.38,5.8,0,4-2.36,5.9-6.63,5.9h-2.61v-5.7h4.55v-1.43h-4.55Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "242.13 197.83 251.87 197.83 251.87 195.86 244.62 195.86 244.62 182.19 242.13 182.19 242.13 197.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.43,182.19H278v8.87c0,3-1,5.06-4.25,5.06s-4.24-2.06-4.24-5.06v-8.87H267v9.16c0,4.39,2.46,6.74,6.73,6.74s6.73-2.35,6.73-6.74v-9.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "297.27 197.83 299.75 197.83 299.75 184.97 299.8 184.97 307.64 197.83 310.82 197.83 310.82 182.19 308.34 182.19 308.34 194.78 308.29 194.78 300.64 182.19 297.27 182.19 297.27 197.83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8dca03aab810957768e9b1d140c13111.svg";
export { ForwardRef as ReactComponent };